import React from "react";
import Footer from "./Footer";

const ImprintPage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <div className="container mx-auto px-4 py-40 max-w-3xl flex-grow">
        <h1 className="text-[3rem] md:text-[4rem] mb-8 text-[#343434]">Impressum</h1>

        <div className="space-y-6 text-[#343434]">
          <section className="space-y-2">
            <p>
              walk in the park UG (haftungsbeschr&auml;nkt),
              <br />
              Theaterplatz 2, 23909 Ratzeburg,
              <br />
              hi@walkinthepark.life
            </p>

            <p>Sitz der Gesellschaft: Hamburg</p>
            <p>Partnerschaftsregister: Amtsgericht Hamburg, HRB 25467 HL</p>
          </section>

          <section className="space-y-2">
            <h2 className="text-xl font-semibold text-[#343434]">
              Geschäftsführer
            </h2>
            <p>Felix Gebauer-Lüdke, Maximilian Wilke</p>
          </section>

          <section className="space-y-2">
            <h2 className="text-xl font-semibold text-[#343434]">
              Umsatzsteueridentifikationsnummer
            </h2>
            <p>DE450175882</p>
          </section>

          <section className="space-y-2">
            <h2 className="text-xl font-semibold text-[#343434]">
              Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV
            </h2>
            <p>Felix Gebauer-Lüdke, Maximilian Wilke</p>
          </section>

          <section className="space-y-2">
            <h2 className="text-xl font-semibold text-[#343434]">
              Online-Streitbeilegung
            </h2>
            <p>
              Plattform der EU zur außergerichtlichen Online-Streitbeilegung:{" "}
              <a
                href="https://ec.europa.eu/consumers/odr/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-tralala-red hover:underline"
              >
                https://ec.europa.eu/consumers/odr/
              </a>
            </p>

            <p>
              Wir sind grundsätzlich nicht bereit oder verpflichtet, an
              Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
              teilzunehmen.
            </p>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ImprintPage;
